import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { sortByLabel } from "../sortby/sortByFilterConfig"
import { Columns } from 'components/elements'


class SortByInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      sortByLabels: sortByLabel(),
      selectedRadio: this.props.selectedRadio
    }
  }

  componentDidMount() {
    //we might grab the URL here on mount. but I don't know if we should or not.
    //might pass these down as defaultValue props.
  }

  componentDidUpdate(prevProp) {
    if (prevProp.selectedRadio !== this.props.selectedRadio) {
      this.setState({
        selectedRadio: this.props.selectedRadio,
      })
    }
  }

  handleSortByChange = e => {
    this.setState({
      selectedRadio: e.target.name
    })
    this.props.onChange(e.target.name)
  }

  buildRadioClassName = () => {
    return "is-flex is-justify-content-flex-start is-align-content-center sort-by-radio-wrapper"
  }

  render() {
    const { sortByLabels, selectedRadio } = this.state

    return (
      <Columns>
        <Columns.Column size={12} className='mt-3'>
          <div className='is-flex is-flex-direction-column'>
            {
              sortByLabels.map((label, index) => (
                <div 
                  className={this.buildRadioClassName()}
                  key={index}
                >
                  <input
                    className="is-checkradio"
                    id={label.key} //id is must else input can't be checked
                    type="radio"
                    name={label.key}
                    value={label.value}
                    checked={selectedRadio == label.key}
                    onChange={(e) => this.handleSortByChange(e)}
                  />
                  <label for={label.key} className='py-0'>
                    {label.value}
                  </label>
                </div>
              ))
            }
          </div>
        </Columns.Column>
      </Columns>
    )
  }
}

export default withRouter(SortByInput)
